import { createSelector, createFeatureSelector } from '@ngrx/store';

import * as fromReducer from '@app/store/reducers/user-alerts.reducer';
import { AlertCollectionState } from '@app/store/reducers/user-alerts.reducer';

export const alertsState = createFeatureSelector<AlertCollectionState>('alerts');

export const selectUserAlertsEntities = createSelector(
  alertsState, fromReducer.selectAll
);
